var Global = {
    init: function() {
        Parser.init();
        Modal.init();
    },
    startMe: function() {
        DropDowns.init();
        Deeplink.init();
    }
}
